{
  "alert.informative": "Informative",
  "alert.negative": "Negative",
  "alert.notice": "Notice",
  "alert.positive": "Positive",
  "chat.newMessage": "הודעה חדשה",
  "chat.scrollToBottom": "גלול למטה",
  "messagefeedback.thumbDown": "תגובה גרועה",
  "messagefeedback.thumbUp": "תגובה טובה",
  "promptfield.aiDisclaimer": "תגובות נוצרות באמצעות בינה מלאכותית, ועלולות להיות לא מדויקות. בדוק לפני השימוש.",
  "promptfield.aiUserGuidlines": "הנחיות למשתמשים בבינה מלאכותית",
  "promptfield.attachments": "תוספות",
  "promptfield.insertButton": "הוסף",
  "promptfield.label": "הנחיה",
  "promptfield.placeholder": "מוכנים להתחיל? שאלו שאלה, שתפו רעיון או הוסיפו משימה.",
  "promptfield.placeholder.small": "Ask anything",
  "promptfield.stopButton": "עצור",
  "promptfield.submitButton": "שלח",
  "promptfield.uploading": "העלאה",
  "responsestatus.loading": "בטעינה…",
  "responsestatus.processing": "Processing...",
  "voicebutton.startListening": "התחל להקליט",
  "voicebutton.stopListening": "הפסק להקליט",
  "attachmentlist.previousAttachments": "Show previous attachments",
  "attachmentlist.nextAttachments": "Show next attachments"
}
